module.exports = __webpack_public_path__ + "static/greenprofile-cd2158b65ac90438ae4db14938af5b77.png";